






















































































































































































































































































































































































































































































import { getEntityPage, navigateTo, replaceTab } from '@/common/RouteUtils';
import RouteTab from '@/components/RouteTab.vue';
import AddJob from '@/components/add business objects/addJob.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import {
	BillingApi,
	Entities,
	EntityLocation,
	EntityStatus,
	Org,
	OrgsApi,
	ProductOrderStatusEnum,
	ProductsApi,
	ProductStatus,
	Sensor,
	SimproJobDetails,
	Tank,
	Transceiver,
} from '@/api';
import addFault from '@/components/add business objects/addFault.vue';
import infoTabs from '@/layouts/parent/BTabsParent.vue';
import AddNote from '@/components/add business objects/addNote.vue';
import Toast from '@/components/display/toast.vue';
import UsersTable from '@/components/tables/users-table.vue';
import ChangeProductOrgModal from '../ChangeProductOrgModal.vue';
import DataTable from '@/components/datatable.vue';
import TitleMixin from '@/mixins/title-mixin';
import { integer } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import routerLinkButton from '@/components/elements/buttons/router-link-button.vue';
import externalLinkButton from '@/components/elements/buttons/external-link-button.vue';
import {
	formatProductTier,
	formatProductTierAttribute,
	getProductBillingAttributes,
	ProductOrdwayAttributes,
} from '@/models/ordway';
import { AxiosError, AxiosResponse } from 'axios';
import { OrdwayService } from '@/services/ordway-service';
import EditChargesModal from '@/pages/account/organisations/billing/EditPlanChargesModal.vue';
import SimPro from '@/components/tables/simPro.vue';
import addOrgToProduct from '@/components/add business objects/addOrgToProduct.vue';
import rebootTransceiver from '@/components/elements/functional buttons/reboot-transceiver.vue';
import TankView from '@/pages/account/products/fuel/tanks/view.vue';
import AddTank from '@/components/add business objects/product/entity/addTank.vue';
import { mixins } from 'vue-class-component';
import BillingSetupForm from '@/components/billing-setup-form/billing-setup-form.vue';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';
import ProductTrialModal from '@/components/ProductTrialModal.vue';
import ProductCountryFlagRow from '@/components/display/product-country-flag-row.vue';
import AddUserForm from '@/components/add business objects/add-user/AddUserForm.vue';
import EntityMap from '@/components/display/maps/entityMap.vue';
import { Constants } from '@/common/Constants';
import { getProductAllowedUserCount, getProductAllowedUserIds } from '@/services/user-service';
import RepairJobTexts from '@/components/tables/repair-job-texts.vue';
import { ProductStatusService } from '@/services/product-status-service';
import AddJobModalsContainer from '@/components/add business objects/add-job/AddJobModalsContainer.vue';
import { LastCheckInService } from '@/services/last-check-in-service';
import { ParsingUtil } from '@/common/ParsingUtil';
import ErrorDiv from '@/components/display/errorDiv.vue';
import FaultStatusRow from '@/components/display/information-rows/fault-status-row.vue';
import InformationRow from '@/components/display/information-row.vue';
import SiteRow from '@/components/display/information-rows/site-row.vue';
import OrgRow from '@/components/display/information-rows/org-row.vue';
import NotesRow from '@/components/display/information-rows/notes-row.vue';
import PlanRow from '@/components/display/information-rows/plan-row.vue';
import DirectRow from '@/components/display/information-rows/direct-row.vue';
import TrialRow from '@/components/display/information-rows/trial-row.vue';
import ChangelogLink from '@/components/display/changelog-link.vue';
import LastCheckInTag from '@/components/display/information-rows/last-check-in-tag.vue';
import ProductActionsBar from '@/components/ProductActionsBar.vue';
import WarningIcon from '@/components/display/warning-icon.vue';
import { PaginationPageProps } from '@/models/pagination-page-props';
import SmsCharges from '@/components/smsCharges/smsCharges.vue';
import { formattedStatus } from '@/common/StatusUtil';
import { getAlertText, showHelpTexts, getOtherActionText } from '@/common/HelpTextUtils';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';

@Component({
	computed: {
		ProductOrderStatusEnum() {
			return ProductOrderStatusEnum;
		},
		ProductStatus() {
			return ProductStatus;
		},
		EntityStatus() {
			return EntityStatus;
		},
	},
	components: {
		RouteTab,
		WarningIcon,
		ProductActionsBar,
		LastCheckInTag,
		ChangelogLink,
		ErrorDiv,
		TrialRow,
		DirectRow,
		PlanRow,
		NotesRow,
		OrgRow,
		SiteRow,
		InformationRow,
		FaultStatusRow,
		AddJobModalsContainer,
		externalLinkButton,
		routerLinkButton,
		secondaryNav,
		UsersTable,
		AddNote,
		AddJob,
		AddTank,
		DataTable,
		Toast,
		EditChargesModal,
		infoTabs,
		addOrgToProduct,
		rebootTransceiver,
		SimPro,
		addFault,
		ChangeProductOrgModal,
		TankView,
		BillingSetupForm,
		BillingSetupButton,
		ProductTrialModal,
		ProductCountryFlagRow,
		AddUserForm,
		RepairJobTexts,
		EntityMap,
		SmsCharges,
		TooltipButton,
	},
	methods: {
		formatProductTier,
		getAlertText,
		showHelpTexts,
		getOtherActionText,
	},
	mixins: [TitleMixin, validationMixin],
})
export default class ProductView extends mixins(validationMixin) {
	get productPlan(): string {
		if (this.productOrdwayAttributes !== null) {
			return this.productOrdwayAttributes.ordwayPlanName;
		}
		return '';
	}

	get partnerPlan(): string {
		if (this.partnerProductOrdwayAttributes !== null) {
			return this.partnerProductOrdwayAttributes.ordwayPlanName;
		}
		return '';
	}

	public get formattedProductStatus(): string {
		return formattedStatus(
			this.product,
			ProductStatusService.formatProductStatus(
				this.product?.status ?? null,
				this.product?.termsState ?? null,
			),
			'product',
		);
	}

	get productTier(): string {
		return formatProductTierAttribute(this.productOrdwayAttributes);
	}

	get billingAttributes() {
		return getProductBillingAttributes(
			this.productOrdwayAttributes,
			this.partnerProductOrdwayAttributes,
			this.product.subscriptionitem,
		);
	}

	public get transceivers(): Transceiver[] {
		return (this.tanks ?? [])
			.filter(tank => tank.transceiver !== null)
			.map(tank => tank.transceiver!);
	}

	public get tankLocations(): {
		entityType: string;
		location: EntityLocation;
		entity: Tank & {
			transceiver: Transceiver | null;
			entitylocation: EntityLocation | null;
		};
	}[] {
		return (this.tanks ?? [])
			.filter(tank => tank.entitylocation !== null)
			.map(tank => ({
				entityType: Constants.ENTITY_TYPE_FUEL_TANK,
				location: tank.entitylocation!,
				entity: tank,
			}));
	}

	public get mapCenter(): { lat: number; lng: number } | null {
		if (
			this.product.site === null ||
			!this.product.site?.latitude ||
			!this.product.site.longitude
		) {
			return null;
		}
		return {
			lat: parseFloat(this.product.site.latitude),
			lng: parseFloat(this.product.site.longitude),
		};
	}

	public smallScreen = window.innerWidth;
	public simProRenderKey = 0;
	public renderKey = 0;
	public visible = true;
	public loading = true;
	public product: any | null = null;
	public files: any | null = null;
	public files2: any | null = null;
	public org: any | null = null;
	public generalInfo: any[] = [];
	public partnerOrgs: Org[] | undefined = [];
	public isOnNewOrdwayPlan: boolean = false;
	public jobsExist = false;
	public get currentPage(): number {
		return getEntityPage(this.$route, this.tanks || [], 'products.fuel.tanks', 'tankId');
	}

	public set currentPage(page: number) {
		if (!this.$route.name?.startsWith('products.fuel.tanks.') || page === this.currentPage) {
			return;
		}
		const tank = this.tanks?.[page - 2];
		if (page !== 1 && !tank) {
			return;
		}
		navigateTo(this.$router, {
			name: tank
				? 'products.fuel.tanks.detail.general.information'
				: 'products.fuel.tanks.overview',
			params: {
				productId: this.$route.params.productId,
				...(tank ? { tankId: String(tank.id) } : {}),
			},
		});
	}

	@Watch('$route', { immediate: true })
	@Watch('tanks')
	public ensureAvailableTab(): void {
		if (
			!this.tanks ||
			String(this.product?.id) !== String(this.$route.params.productId) ||
			!this.$route.name?.startsWith('products.fuel.tanks.detail.') ||
			this.currentPage !== 1
		)
			return;
		replaceTab(this.$router, 'products.fuel.tanks.overview');
	}
	private readonly perPage = 1;
	public simproJobs: SimproJobDetails[] = [];

	public form = { type: '', users: [] };

	public options = [
		{ value: 'milkTooWarm', text: 'Milk is too warm' },
		{ value: 'milkTooCold', text: 'Milk is too cold' },
		{ value: 'stirrerOffMilkInVat', text: 'Stirrer not running' },
		{ value: 'milkPickup', text: 'Milk Pickup' },
	];

	public planOptions = [
		{ value: 'regular', text: 'Regular' },
		{ value: 'super', text: 'Super' },
		{ value: 'trial', text: 'Trial' },
	];

	public partnerFields: any[] | null = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{
			key: 'contributionTier',
			label: 'Contribution Tier',
			formatter: (val: string) => Vue.filter('titleCase')(val),
		},
	];

	public users: any[] | null = null;
	public allowedUserIds: number[] | null = null;
	public audits: any[] | null = null;
	public fields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public billingAudits: any[] | null = null;
	public billingAuditsFields: any[] | null = [
		{ key: 'created_at', label: 'Date Sent' },
		{ key: 'event', label: 'Event' },
		{ key: 'from', label: 'From' },
		{ key: 'to', label: 'To' },
		{ key: 'user.name', label: 'By' },
	];

	public transceiverFields: any[] | null = [
		{ key: 'transceiver.id', label: 'Id', sortable: true },
		{ key: 'name', label: 'Tank Name', sortable: true },
		{ key: 'transceiver.createdAt', label: 'Created', sortable: true },
		{ key: 'transceiver.serialNumber', label: 'Serial Number', sortable: true },
		{ key: 'transceiver.imei', label: 'IMEI', sortable: true },
		{ key: 'transceiver.firmwareVersion', label: 'Firmware' },
		{ key: 'lastCheckIn', label: 'Last Check In' },
		{ key: 'reboot', label: 'Reboot' },
	];
	public tanks:
		| (Tank & {
				transceiver: Transceiver | null;
				entitylocation: EntityLocation | null;
		  })[]
		| null = null;

	public tanksFields: any[] = [
		{ key: 'id', label: 'Id' },
		{ key: 'name', label: 'Name' },
		{ key: 'status', label: 'Status' },
		{ key: 'transceiver.serialNumber', label: 'Transceiver' },
		{ key: 'sensor.serialNumber', label: 'Sensor' },
		{ key: 'sensor.lastCheckIn', label: 'Last Checked In' },
	];
	public click?: (item: any, index: number, e: Event) => void;
	public filters?: any;
	public productOrdwayAttributes: ProductOrdwayAttributes | null = null;
	public syncing: boolean = false;
	private api: ProductsApi = new ProductsApi();
	private partnerProductOrdwayAttributes: ProductOrdwayAttributes | null = null;
	private currentBilling: any | null = null;
	private productStatusService: ProductStatusService<Tank> = new ProductStatusService<Tank>(
		this.product,
	);

	public canAddUser: boolean = false;

	private productId?: number | null;

	public entityTypes: Entities[] = [Entities.Tanks];

	public get canCreateInstallJobs(): boolean {
		if (!this.product) {
			return false;
		}
		const pendingEntities = this.product.tanks.map(tank => tank.status).includes('pending');
		return pendingEntities;
	}

	public getPaginationListItem(page) {
		return [{ name: 'Overview' }].concat(this.tanks)[page - 1];
	}
	public rowClickHandler(item: Tank) {
		const index = this.tanks?.findIndex(tank => tank.id === item.id) ?? -1;
		if (index >= 0) {
			this.currentPage = index + 2;
		}
	}

	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}

	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}

	public loadSimpro() {
		this.simProRenderKey === 0 ? (this.simProRenderKey += 1) : (this.simProRenderKey -= 1);
	}

	public reRender() {
		this.renderKey > 0 ? this.renderKey-- : this.renderKey++;
	}

	public newFault(e: Event) {
		this.product.faults.push(e);
	}

	public pageTitle() {
		return `Fuel | ${this.product ? this.product.name : ''}`;
	}

	public async load() {
		if (this.productId == null) {
			this.loading = false;
			return;
		}

		await this.loadProduct();
		await this.loadPartners();
		await this.loadBilling();

		this.productStatusService = new ProductStatusService<Tank>(this.product);
	}

	public async loadUsers() {
		const product = await this.loadProduct('users');
		this.users = product.users;
		this.users.forEach(user => {
			this.form.users.push(Object.assign({ checked: false, sms: false, id: user.id }, user));
		});
		this.reRender();
	}

	public async loadPartners() {
		try {
			const data = await new ProductsApi().getProductPartnerOrgs(this.productId!);
			this.partnerOrgs = data.data.data.filter(p => p !== null);
		} catch (e) {
			this.partnerOrgs = undefined;
			console.log(e);
		}
	}

	public async loadProduct(e: Event) {
		try {
			const { data } = await this.api.getProductById(this.productId!, {
				params: {
					include:
						'org,audits,' +
						'audits.user,' +
						'tanks,' +
						'tanks.distributor,' +
						'tanks.sensor,' +
						'tanks.transceiver,' +
						'site,' +
						'faults,' +
						'faults.owner,' +
						'subscriptionitem,' +
						'subscriptionitem.audits,' +
						'subscriptionitem.audits.user,' +
						'users,tanks.entitylocation,' +
						'site.address,' +
						'discount',
				},
			});
			this.users = data.users;
			this.product = data;
			this.org = data.org || {};
			this.generalInfo = [
				{ text: 'Name', value: data.name },
				{ text: 'Status', value: data.status || '' },
				{ text: 'Created At', value: this.$options.filters.longDateTime(data.createdAt) || '' },
				{ text: 'Live At', value: this.$options.filters.longDateTime(data.liveAt) },
				{ text: 'Site', value: data.site.name || '' },
				{ text: 'Organisation', value: data.org.name || '' },
				{ text: 'Notes', value: data.notes || '' },
			];
			if (data.subscriptionitem !== null) {
				this.generalInfo = [
					...this.generalInfo,
					{ text: 'Product Plan', value: data.subscriptionitem.plan || '' },
					{ text: 'Trial Plan', value: data.subscriptionitem.trialPlan || '' },
					{
						text: 'Trial Ends',
						value: this.$options.filters.longDateTime(data.subscriptionitem.trialEndsAt) || '',
					},
				];
			} else {
				this.generalInfo = [
					...this.generalInfo,
					{ text: 'Payment Method', value: '' },
					{ text: 'Product Plan', value: 'Subscription Item Not Set' },
					{ text: 'Trial Plan', value: '' },
					{ text: 'Trial Ends', value: '' },
				];
			}
			this.audits = data.audits;
			this.billingAudits = data?.subscriptionitem?.audits ?? [];

			this.tanks = data.tanks.sort(
				(a, b) => (this.getStatusPriority(a.status) > this.getStatusPriority(b.status) && 1) || -1,
			);

			for (const entity of this.tanks as any[]) {
				if (entity.sensor) {
					const lastCheckInResponse = await LastCheckInService.getLastCheckIn(
						'sensor',
						entity.sensor.id,
					);
					if (!lastCheckInResponse.errorMessage) {
						entity.sensor.lastCheckIn = lastCheckInResponse.lastCheckInTimestamp;
					}
				}
			}

			await this.fetchProductOrdwayAttribute();

			if (this.productOrdwayAttributes) {
				this.isOnNewOrdwayPlan = await OrdwayService.isOnNewOrdwayPlan(
					this.product,
					this.productOrdwayAttributes,
				);
			}

			this.allowedUserIds = await getProductAllowedUserIds(this.product.id);
			const allowedUserCount = await getProductAllowedUserCount(this.product.id);
			this.canAddUser =
				allowedUserCount == null ||
				(this.product?.users && this.product?.users?.length < allowedUserCount);
		} catch (e) {
			console.log(e);
			this.product = null;
		} finally {
			this.loading = false;
			this.reRender();
		}

		// this.loadUsers();
	}

	// When next touched, refactor. See water product view.vue for an example
	public async loadBilling() {
		try {
			const billingData = await new BillingApi().currentBilling(this.productId!);
			this.currentBilling = billingData.data.data;

			if (this.currentBilling.partnerId !== null) {
				const partners = await new OrgsApi().orgGetBillingPartnersByProductType('fuel');
				const partner = partners.data.data?.find(
					partner => partner.id == this.currentBilling.partnerId,
				);
				if (partner) {
					this.currentBilling = { ...this.currentBilling, partnerName: partner.name };
				}
			}
		} catch (e) {
			console.log(e);
		}
	}

	private getStatusPriority(status: string): integer {
		switch (status) {
			case 'live':
				return 1;
			case 'pending':
				return 2;
			case 'install':
				return 3;
			case 'sign-off':
				return 4;
			case 'removed':
				return 5;
			case 'cancelled':
				return 6;
			default:
				return 0;
		}
	}

	public async created() {
		this.productId = ParsingUtil.parseId(this.$route.params.productId);
		await this.onCreated();

		this.$watch(
			() => this.$route.params.productId,
			async (to, from) => {
				this.productId = ParsingUtil.parseId(to) ?? this.productId;
				await this.onCreated();
			},
		);
	}

	private async onCreated() {
		window.addEventListener('resize', this.myEventHandler);
		await this.load();
		if (
			this.productOrdwayAttributes === null &&
			this.product.status !== 'cancelled' &&
			this.product.status !== 'removed'
		) {
			(this.$refs.billingSetupButton as BillingSetupButton).openEditBillingModal();
		}
	}

	public signOffTank(tank) {
		this.$router.push({ name: 'products.fuel.tank.sign-off', params: { tankId: tank.id } });
	}

	public openProductOrgChangeModal(): void {
		this.$bvModal.show('product-org-change-modal');
	}

	public closeOrgModal(): void {
		this.$bvModal.hide('product-org-change-modal');
	}

	public async onOrgChanged() {
		await this.loadProduct();
		this.closeOrgModal();
		new Toast().makeToast('Org changed successfully', 'Success', 'success', false);
	}

	public async resetProductOrg() {
		await this.loadProduct();
	}

	public setJobsToTrue() {
		this.jobsExist = true;
	}

	public simproJobsLoaded(simproJobs: SimproJobDetails[]) {
		this.simproJobs = simproJobs;
	}

	public async syncOrdwayDraftSubscription() {
		this.syncing = true;
		await OrdwayService.syncOrdwayDraftSubscription(this.product.id);
		this.loadProduct();
		this.syncing = false;
		new Toast().makeToast('Ordway Draft Subscription synchronised', 'Successful', 'success');
	}

	private async fetchProductOrdwayAttribute(): Promise<void> {
		try {
			const productOrdwayAttributeResponse: AxiosResponse<ProductOrdwayAttributes> = await OrdwayService.fetchProductOrdwayAttributes(
				this.product.id,
				this.product.orgId,
			);
			this.productOrdwayAttributes = productOrdwayAttributeResponse.data;
		} catch (errorResponse) {
			const error: AxiosError = errorResponse as AxiosError;
			if (error.response) {
				const errorMessage = error.response.data.errors;
				new Toast().makeToast(errorMessage, 'No plan found for this product', 'danger', false);
			} else {
				new Toast().makeToast(
					'There was a problem loading the Ordway attributes for this product, please let the software team know',
					'Error loading Ordway attributes',
					'danger',
					true,
				);
			}
		}
	}

	public get partnerContribution(): string {
		return `${
			this.currentBilling && this.currentBilling.partnerContributionTier
				? `${this.$options.filters?.capitalise(
						this.$options.filters?.decamelize(this.currentBilling.partnerContributionTier),
				  )} | ${this.currentBilling.partnerName}`
				: 'No Contribution'
		}`;
	}
}
